import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 960px;
  margin: 0 auto;
`;

export const Container = styled.div`
  min-height: calc(100vh - 104px - 178px);
`;
